// 이미지 위에 하단 그라디언트 + 캡션을 얹는 이미지 박스
export default function CaptionImg({
    src,
    caption,
    className = "",
}: {
    src: string;
    caption: string;
    className?: string;
}) {
    return (
        <div className={`relative overflow-hidden ${className}`}>
            <img src={src} alt={caption} className="w-full" />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent from-[48.5%] to-black opacity-60" />
            <p className="absolute bottom-[16px] left-0 w-full text-center font-['GongGothicMedium'] text-[16px] leading-[1.6] tracking-[-0.25px] text-white md:bottom-[30px] md:text-[28px]">
                {caption}
            </p>
        </div>
    );
}
